/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { PlayerStatBestHandWonModel, PlayerStatBestHandWonModelType } from './PlayerStatBestHandWonModel'
import { PlayerStatBestHandWonModelSelector } from './PlayerStatBestHandWonModel.base'
import { PlayerStatBiggestWinModel, PlayerStatBiggestWinModelType } from './PlayerStatBiggestWinModel'
import { PlayerStatBiggestWinModelSelector } from './PlayerStatBiggestWinModel.base'
import { StatsKindEnumType } from './StatsKindEnum'
import { RootStoreType } from './index'

/**
 * PlayerGameStatsBase
 * auto generated base class for the model PlayerGameStatsModel.
 */
export const PlayerGameStatsModelBase = ModelBase.named('PlayerGameStats')
  .props({
    __typename: types.optional(types.literal('PlayerGameStats'), 'PlayerGameStats'),
    bestHandWon: types.union(
      types.undefined,
      types.null,
      types.late(() => PlayerStatBestHandWonModel)
    ),
    biggestWin: types.union(
      types.undefined,
      types.null,
      types.late(() => PlayerStatBiggestWinModel)
    ),
    gameId: types.union(types.undefined, types.string),
    gameStartTime: types.union(types.undefined, types.number),
    gameType: types.union(types.undefined, types.string),
    kind: types.union(types.undefined, types.null, StatsKindEnumType),
    numberOfHands: types.union(types.undefined, types.number),
    numberOfHandsPlayed: types.union(types.undefined, types.number),
    numberOfHandsWon: types.union(types.undefined, types.number),
    numberOfHandsWonAtShowdown: types.union(types.undefined, types.number),
    numberOfPreFlopFolds: types.union(types.undefined, types.number),
    rank: types.union(types.undefined, types.number),
    userId: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PlayerGameStatsModelSelector extends QueryBuilder {
  get gameId() {
    return this.__attr('gameId')
  }
  get gameStartTime() {
    return this.__attr('gameStartTime')
  }
  get gameType() {
    return this.__attr('gameType')
  }
  get kind() {
    return this.__attr('kind')
  }
  get numberOfHands() {
    return this.__attr('numberOfHands')
  }
  get numberOfHandsPlayed() {
    return this.__attr('numberOfHandsPlayed')
  }
  get numberOfHandsWon() {
    return this.__attr('numberOfHandsWon')
  }
  get numberOfHandsWonAtShowdown() {
    return this.__attr('numberOfHandsWonAtShowdown')
  }
  get numberOfPreFlopFolds() {
    return this.__attr('numberOfPreFlopFolds')
  }
  get rank() {
    return this.__attr('rank')
  }
  get userId() {
    return this.__attr('userId')
  }
  bestHandWon(
    builder:
      | string
      | PlayerStatBestHandWonModelSelector
      | ((selector: PlayerStatBestHandWonModelSelector) => PlayerStatBestHandWonModelSelector)
      | undefined
  ) {
    return this.__child('bestHandWon', PlayerStatBestHandWonModelSelector, builder)
  }
  biggestWin(
    builder:
      | string
      | PlayerStatBiggestWinModelSelector
      | ((selector: PlayerStatBiggestWinModelSelector) => PlayerStatBiggestWinModelSelector)
      | undefined
  ) {
    return this.__child('biggestWin', PlayerStatBiggestWinModelSelector, builder)
  }
}
export function selectFromPlayerGameStats() {
  return new PlayerGameStatsModelSelector()
}

export const playerGameStatsModelPrimitives =
  selectFromPlayerGameStats().gameId.gameStartTime.gameType.kind.numberOfHands.numberOfHandsPlayed.numberOfHandsWon
    .numberOfHandsWonAtShowdown.numberOfPreFlopFolds.rank.userId
